import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

/**
 * Notification document interface
 */
export interface NotificationDocument extends BaseDocument {
  userId: string
  entityType: string | null
  entityId: string | null
  type: string // Changed from notificationType to match backend
  title: string
  message: string | null
  actionUrl: string | null
  isRead: boolean
  readAt: number | null
  priority: number // Added
  reminderId: string | null // Added
  triggeredByName: string | null
  triggeredByEmail: string | null
}

/**
 * Notification-specific hooks
 */
const hooks = createEntityHooks<NotificationDocument>('notifications')

export const useNotifications = (filter?: Partial<NotificationDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { notifications: data, isLoading, db }
}

export const useNotification = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { notification: data, isLoading }
}

export const useNotificationMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createNotification: create,
    updateNotification: update,
    deleteNotification: deleteEntity,
  }
}
